<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>转化数据</el-breadcrumb-item>
    </el-breadcrumb>
    <ex-table
      ref="table"
      :load-and-request="false"
      :init="initOptions"
      :request="fetchData"
    >
      <ex-table-column
        prop="date"
        label="日期"
        align="center"
        width="120"
        search-key="time"
        data-type="date"
        start-time-key="startDate"
        end-time-key="endDate"
      ></ex-table-column>
      <ex-table-column
        prop="source"
        label="来源"
        align="center"
        width="120"
        :multiple="true"
        search-key="source"
        data-type="select"
        :options="sourceOptions"
      ></ex-table-column>
      <ex-table-column
        prop="preRegisterCount"
        label="预注册人数"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="registerCount"
        label="注册人数"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="newCustomerCount"
        label="0新客户"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="unhandledPhoneCount"
        label="1未接电话，待沟通"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="handledPhoneCount"
        label="2已接通，未深入沟通"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="interestedCustomerCount"
        label="3意向客户，未确定到店时间"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="interestedCustomerWithVisitTimeCount"
        label="4意向客户，已确定到店时间"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="noShowCount"
        label="5爽约，待再次沟通"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="strongIntentCustomerCount"
        label="6已到店，意向很强，紧跟"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="noIntentCustomerCount"
        label="7已到店，无意向"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="depositCustomerCount"
        label="8已付定金，建档用户"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="vipCount"
        label="9已成交vip会员"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="serviceInProgressCount"
        label="10服务中"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="guidanceMeetingCount"
        label="11推动见面指导"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="matchingMeetingCount"
        label="12撮合再见面"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="deepRelationshipCount"
        label="13深入交往推动恋爱"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="confirmRelationshipCount"
        label="14确认恋爱"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="marriageCertificateCount"
        label="15已领结婚证"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="serviceSuspendedCount"
        label="16暂停服务"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="servicePausedCount"
        label="17服务暂停"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="refundAgreementPendingCount"
        label="18已共识退费，未签解约协议"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="refundCustomerCount"
        label="19已退费客户"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="serviceExpiredCount"
        label="20服务过期"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="notConsideredCount"
        label="21完全不考虑"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="notSingleCount"
        label="22不是单身"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="parentsMarriageCount"
        label="23父母替子女征婚"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="activityParticipationCount"
        label="24只参加活动"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="youngRegistrationCount"
        label="25年龄小注册完"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="invalidResourceCount"
        label="26无效放弃资源"
        align="center"
      ></ex-table-column>
    </ex-table>
  </div>
</template>

<script>
import {pageStatCustomerTransferData, statCustomerTransferSourceList} from "../../api/statMG";
import {DataType} from "../../components/ExTable/ExTableEnum";

export default {
  name: 'DailyData',
  computed: {
    DataType() {
      return DataType
    }
  },
  data() {
    return {
      tableData: [],
      sourceOptions: [],
    };
  },
  methods: {
    async initOptions() {
      let res = await statCustomerTransferSourceList();
      this.sourceOptions = res.data.map(item => ({
        value: item,
        label: item
      }));
    },
    async fetchData(params) {
      let res = await pageStatCustomerTransferData(params)
      return new Promise((c) => {
        c({
          records: res.data.records,
          total: res.data.total
        })
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.table.search();
    })
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/stat/CustomerTransferData.vue